
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdf",
      function () {
        return require("private-next-pages/pdf/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pdf"])
      });
    }
  